import { createContext, useContext, useState } from "react";

export const useDoubleSidebarProvider = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isFirst, setIsFirst] = useState(false);
  const [isLast, setIsLast] = useState(false);
  const [expandedLabels, setExpandedLabels] = useState<Record<string, boolean>>(
    {}
  );

  return {
    isCollapsed,
    setIsCollapsed,
    isFirst,
    setIsFirst,
    isLast,
    setIsLast,
    expandedLabels,
    setExpandedLabels
  };
};

export const DoubleSidebarProvider = ({ children }) => {
  const doubleSidebarProvider = useDoubleSidebarProvider();

  return (
    <DoubleSidebarContext.Provider value={doubleSidebarProvider}>
      {children}
    </DoubleSidebarContext.Provider>
  );
};

export const DoubleSidebarContext = createContext(null);
export const useDoubleSidebar = () => useContext(DoubleSidebarContext);
